import React from 'react'
import { IconButton } from '@mui/material';
import DefaultVideoPlayer from 'components/UI/mediaPlayers/defaultVideoPlayer';
import {Movie} from '@mui/icons-material';
import color from 'utils/constants/color';
import { PlacementExamStopIcon } from 'utils/assets/images';
import { Modal } from "antd";
import { goFullScreen } from "utils";
export default function SectionVideoPlayer({ videoUrl, is_placement= false }) {
    const [openVideoModal, setOpenVideoModal] = React.useState(false);

    const handleClose = (modal) => {
        setOpenVideoModal(false);
    };
    if(!videoUrl) return null;
    return (<>
    <IconButton style={{ backgroundColor:color.green1000 , height:28 , width:28, marginLeft:6 }} onClick={() => setOpenVideoModal(true)}><Movie style={{ color:color.white , height:"0.8em"}}/></IconButton>
        <DefaultVideoPlayer openVideoModal={openVideoModal} handleClose={() => handleClose()} video={videoUrl} is_placement={is_placement} />
    </>)
}



export const FullScreenModal = ({ onOk, show,isTabAndMobile = false }) => {
    const onOkClick = () =>{
        onOk();
        if(isTabAndMobile) return;
        goFullScreen();
    }
    return (
      <Modal
        className="studentQuestionModal"
        open={show}
        footer={null}
        closable={false}  
        maskClosable={false} 
      >
        <div className="stdntModalTxt">
          <img src={PlacementExamStopIcon} />
          <p>
          Por favor permanezca en modo de pantalla completa.
          </p>
        </div>
        <div style={{ textAlign: "right" }}>
          <button onClick={onOkClick} className="next-button">
            OK
          </button>
        </div>
      </Modal>
    );
  };